import { Loader, VText } from '@vake/ui-kit';
import { FC } from 'react';
import { useGetSanctionedVesselsQuery } from '../requests/actor-mode';
import { useSendToMattermost } from '../requests/reports';
import { formatRelativeTime } from '../shared/components/time';
import { ErrorHandler } from '../utils/errorHandling';
import { ActorModeRow } from './Report/components/morning-meeting-row';

const ActorMode: FC = () => {
    const { data: sanctionedVessels, isLoading, isError } = useGetSanctionedVesselsQuery();
    const { mutate } = useSendToMattermost();
    const headers = [
        'Name',
        'IMO',
        'Flag & MMSI',
        'Last Updated',
        'Last Position (lat, lon)',
        'Actions last 6 months',
        '',
    ];
    const handleOnClick = (vesselId: string) => {
        mutate(`In Morning Meeting: User clicked on vessel with ID ${vesselId}`);
    };
    const now = new Date();
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    return (
        <div className="flex flex-col p-16 gap-16 max-w-[1536px] mx-auto">
            <div>
                <VText variant="H1">Sanctioned Vessels in NØS with Satellite Images</VText>
                <VText>
                    In period: {formatRelativeTime(yesterday)} - {formatRelativeTime(now)}
                </VText>
            </div>
            <div className="flex flex-col gap-7">
                <div className="grid grid-cols-lmmmmss">
                    {headers.map((header) => (
                        <VText significance="tertiary" key={header} variant="D1B">
                            {header}
                        </VText>
                    ))}
                </div>
                <div className="flex flex-col gap-7 text-label-primary">
                    <ErrorHandler isError={isError} errorMessage={'Loading Sanctioned Vessels Failed'}>
                        <VText variant="H3">Loading Failed</VText>
                        <VText>Something went wrong on our end</VText>
                    </ErrorHandler>
                    {isLoading && (
                        <div className="flex justify-center">
                            <Loader size={16} />
                        </div>
                    )}
                    {sanctionedVessels &&
                        sanctionedVessels.map((report) => (
                            <ActorModeRow key={report.vessel_id} row={report} onClick={handleOnClick} />
                        ))}
                </div>
            </div>
        </div>
    );
};

export default ActorMode;
